import axios from 'axios';
import qs from 'qs'
import { getEnv, getBaseUrl, loginPage } from '../util/config';
import { CRM_TOKEN, CRM_USER_INFO, CRM_LATEST_AJAX_TIME, } from './keys';
import { getCookie, setCookie } from 'cookieUtils';
import { Message } from 'element-ui';
let prefix = getEnv();
let userInfo = localStorage.getItem(CRM_USER_INFO);
if (userInfo) {
    userInfo = JSON.parse(userInfo);
}
let updateSignTime = ()=>{
    localStorage.setItem(CRM_LATEST_AJAX_TIME,Date.now())
}
/*if (prefix == 'dev-') {
 axios.defaults.baseURL = '//test-crm.songshuai.com/api';
 } else {
 axios.defaults.baseURL = `//${prefix}crm.songshuai.com`;
 }*/
//请求拦截器
// let cancel, promiseArr = {}
// const CancelToken = axios.CancelToken;
// axios.interceptors.request.use(config => {
//     //发起请求时，取消掉当前正在进行的相同请求
//     if (promiseArr[config.url]) {
//         promiseArr[config.url]('操作取消')
//         promiseArr[config.url] = cancel
//     } else {
//         promiseArr[config.url] = cancel
//     }
//     return config
// }, error => {
//     return Promise.reject(error)
// })
axios.withCredentials = true;
axios.defaults.baseURL = getBaseUrl();
axios.defaults.headers.post['Content-Type'] = "application/json; charset=UTF-8";
axios.interceptors.request.use(function(config) {
    let innerUrl = config.data && config.data.indexOf('innerUrl') != -1 ? JSON.parse(config.data).innerUrl : null;
    if (innerUrl) {
        if (prefix == 'test-') {
            config.url = `httts://test-crm.songshuai.com/innerapi${innerUrl}`;
        } else {
            config.url = `//${prefix}crm.songshuai.com/innerapi${innerUrl}`;
        }
    }
    let GDSID = getCookie(`${prefix}GDSID`);
    let token = getCookie(CRM_TOKEN);
    // 非登录和获取login接口，且不在登录页面时才检查token
    if (config.url && config.url.indexOf('token') === -1 && config.url.indexOf('Login/GetUserNameLoginStatus') === -1 && token == undefined && location.href.indexOf('login') === -1 && (location.href.indexOf('/order/erpDetails') === -1)) {
        localStorage.clear();
        // 设置过期时间为过去，删除 cookie
        setCookie(CRM_TOKEN, undefined, { expires: new Date(0) });
        location.href = loginPage();
    }
    // 确保 config.headers 存在
    if (!config.headers) {
        config.headers = {};
    }
    if (config.url && config.url.indexOf('/token') === -1) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers[`GDSID`] = GDSID;
    updateSignTime();
    return Promise.resolve(config);
}, function(error) {
    return Promise.reject(error);
});
axios.interceptors.response.use(function(response) {
    // 获取token接口不校验，直接返回
    if (response.config.url.indexOf('token') !== -1) {
        return Promise.resolve(response.data);
    }
    // 登录失效
    if (response.data && (response.data.status === 100 || response.data.errorNo === 100 || response.data.status === 2) && (location.href.indexOf('/order/erpDetails') === -1)) {
        localStorage.clear();
        // 设置过期时间为过去，删除 cookie
        setCookie(CRM_TOKEN, undefined, { expires: new Date(0) });
        location.href = loginPage();
        return;
    }
    if (response.data && (!!response.data.status || !!response.data.errorNo) ) {
        //接口请求时执行 (新的数据接口需要额外配置)
        Message({
            message: response.data.info || response.data.message,
            showClose: true,
            type: 'warning'
        });
    }
    return Promise.resolve(response.data);
}, function(error) {
    // 获取token接口不校验，直接返回
    if (error.config && error.config.url.indexOf('token') !== -1) {
        error.message = error.response.data.error_description
    }
    if (error.response && error.response.data && error.response.data.status == 100 && (location.href.indexOf('/order/erpDetails') === -1)) {
        localStorage.clear();
        // 设置过期时间为过去，删除 cookie
        setCookie(CRM_TOKEN, undefined, { expires: new Date(0) });
        location.href = loginPage();
    }
    Message({
        message: error.message,
        showClose: true,
        type: 'warning'
    });
    return Promise.reject(error);
});
export default class CRMAxios {
    constructor(options = {}) {
        this.options = options;
    }

    request(options) {
        return axios.request(options);
    }

    get(url, data = {},options = {}) {
        return this.request({
            url,
            params: {
                ...data
            },
            // cancelToken: new CancelToken(c => {
            //     cancel = c
            // })
            paramsSerializer: function (params) {  
                return qs.stringify(params, { arrayFormat: "repeat" });  
            },
            ...options
        })
    }

    post(url, data, options = {}) {
        if (data instanceof Object) {
            data = JSON.stringify(data);
        }
        return this.request({
            method: 'post',
            url,
            data,
            // cancelToken: new CancelToken(c => {
            //     cancel = c
            // }),
            ...options
        });
    }
}
const instanceAxios = new CRMAxios;
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);

